














































































































import { Component, Vue, Watch } from 'vue-property-decorator';
import { ReportsService } from '../services/ReportsService';
import { ReportWeeksService } from '../services/ReportWeeksService';
import { ConfigsService } from '../services/ConfigsService';
import { InsectDamageReport } from '../models/insectDamageReport';
import { ReportsForTrapGroup } from '../models/reportsForTrapGroup';
import { ReportWeek } from '../models/reportWeek';
import { PointStyleRule } from '../models/pointStyleRule';
import { Point } from '../models/point';
import { Config } from '@/utils/Config';
import { Helpers } from '@/utils/Helpers';
import { Consoler } from '@/utils/Consoler';
import { EventBus } from '../utils/EventBus';
import AlexMap from '@/components/AlexMap.vue';
import MapLeftSidebar from '@/components/MapLeftSidebar.vue';
import MapLegend from '@/components/MapLegend.vue';
import SummaryCharts from '@/components/SummaryCharts.vue';
import $ from 'jquery';

interface SliderRangeItem {
  label: string;
  isHide: boolean;
}

@Component({
  components: {
    AlexMap,
    MapLeftSidebar,
    MapLegend,
    SummaryCharts
  }
})
export default class Main extends Vue {
  private readonly year: number = Config.Settings.Year;

  private selectedWeek: number | null = null;
  private allReportsPerTrapGroup: ReportsForTrapGroup[] = [];
  private allReportWeeks: ReportWeek[] = [];
  private pointStyleRules: PointStyleRule[] = [];
  private initializing: boolean = false;
  private initialized: boolean = false;
  private loading: boolean = false;
  private error: boolean = false;
  private isFullScreen: boolean = false;
  private showSidebarRight: boolean = false;
  private selectedPoint: Point | null = null;

  private loadUsedRealData: boolean = false;
  private useRealData: boolean = false;
  
  private showingSummaryCharts: boolean = false;
  
  private slider: {
    value: number,
    data: number[],
    range: SliderRangeItem[]
  } = {
    value: 0,
    data: [],
    range: []
  };
  private sliderSelectedWeekNumber: number | null = null;

  private get showFakeSwitch(): boolean {
      return Config.Settings.UseDataSwitch;
  }
  private get sliderOnTopNotBottom(): boolean {
      return Config.Settings.SliderOnTop;
  }
  private get showSlider(): boolean {
    return this.allReportWeeks.length > 1;
  }
  
  mounted() {
    EventBus.$on(Config.MapSetFullScreenEvent, (isFullScreen: boolean) => {
      this.isFullScreen = isFullScreen;
      setTimeout(() => {
        // Workaround to force slider to redraw
          Helpers.DispatchWindowEvent('resize');
      }, 300);
    });
    EventBus.$on(Config.MapSetShowSidebarRightEvent, (show: boolean) => {
      this.showSidebarRight = show;
    });
    EventBus.$on(Config.MapPointSelectedEvent, (point: Point | null) => {
      this.selectedPoint = point;
      setTimeout(() => {
        // Workaround to force slider to redraw
          Helpers.DispatchWindowEvent('resize');
      }, 300);
    });

    this.initializing = true;
    this.useRealData = Helpers.GetQueryParameter('fakeData') !== 'true';

    setTimeout(() => {
      this.load()
        .finally(() => {
          this.initializing = false;
        });
    });
  }

  // Watch 'selectedPoint' for changes
  @Watch('useRealData', { immediate: false, deep: false })
  private onUseFakeDataChange() {
    if (this.initialized && this.loadUsedRealData !== this.useRealData) {
      const url = Helpers.GetLocationWithoutQuery() + '?fakeData=' + (this.useRealData ? 'false' : 'true');
      window.location.href = url;
    }
  }

  private showSummaryCharts() {      
    // Capture the esc key click as unity does
    // (couldn't catch the 'modal.closing' or 'modal.closed' event from unity for some reason)
    $(document).on('keyup.summaryCharts', (e) => {
      if (e.key === 'Escape') {
        this.hideSummaryCharts();
      }
    });

    this.showingSummaryCharts = true;
  }

  private hideSummaryCharts() {  
      // disable the event so it won't continue to trigger    
      $(document).off('keyup.summaryCharts');

      this.showingSummaryCharts = false;
  }

  private onSliderRangeChange() {
    this.$nextTick(() => {
      if (this.sliderSelectedWeekNumber === null ||
          (this.selectedWeek !== null && this.selectedWeek === this.sliderSelectedWeekNumber)) {
        return;
      }

      // Find the matching report week
      this.allReportWeeks.forEach(reportWeek => {
        if (reportWeek.week === this.sliderSelectedWeekNumber) {
          this.selectedWeek = reportWeek.week;
          this.updateReports();
          return;
        }
      });
    });
  }

  private onSelectedReportWeekChanged() {
    if (this.selectedWeek !== null) {
      this.sliderSelectedWeekNumber = this.selectedWeek;
    }
    this.updateReports();
  }

  private onCloseSidebar() {
    this.clearSelectedPoints();
  }

  private clearSelectedPoints() {
    this.selectedPoint = null;
    EventBus.$emit(Config.MapClearSelectedPointsEvent);
    setTimeout(() => {
      // Workaround to force slider to redraw
        Helpers.DispatchWindowEvent('resize');
    }, 300);
  }

  private load(): Promise<any> {
    this.loading = true;
    this.loadUsedRealData = Helpers.GetQueryParameter('fakeData') !== 'true';

    return Promise.all([
      this.loadPointStyleRules(),
      this.loadReportWeeks(),
      this.loadReports()
    ])
      .then(() => {
        if (this.allReportWeeks.length > 0) {
          this.updateReports();
        }
      })
      .catch(() => {
        this.error = true;
      })
      .finally(() => {
        this.loading = false;
        this.initialized = true;
      });
  }

  private loadPointStyleRules(): Promise<any> {
    return ConfigsService.getPointStyleRules()
      .then(response => {          
        const pointStyleRules: PointStyleRule[] = response && response.data;
        Consoler.debugLog('Successfully fetched point style rules from API', pointStyleRules);
        this.pointStyleRules = pointStyleRules;
        EventBus.$emit(Config.MapSetPointStyleRulesEvent, pointStyleRules);
      })
      .catch(error => {
        Consoler.debugWarn('Failed to fetch point style rules from API', error);
        return Promise.reject(error);
      });
  }
  
  private loadReportWeeks(): Promise<any> {
    return ReportWeeksService.getReportWeeks(this.year)
      .then(response => {
        const reportWeeks: ReportWeek[] = response && response.data;
        Consoler.debugLog('Successfully fetched report weeks from API', reportWeeks);

        this.setSliderData(reportWeeks);
        this.allReportWeeks = reportWeeks;

        // Set selected report week to the first one (if any)
        if (this.allReportWeeks.length > 0) {
          this.selectedWeek = this.allReportWeeks[this.allReportWeeks.length - 1].week;
          this.sliderSelectedWeekNumber = this.selectedWeek;
        }
      })
      .catch(error => {
        Consoler.debugWarn('Failed to fetch report weeks from API', error);
        return Promise.reject(error);
      });
  }

  private loadReports(): Promise<any> {      
    return ReportsService.getAggregatedReports(this.year)
      .then((response) => {          
        const reports: ReportsForTrapGroup[] = response && response.data;
        Consoler.debugLog('Successfully fetched aggregated reports from API', reports);
        this.allReportsPerTrapGroup = reports;
      })
      .catch(error => {
        Consoler.debugWarn('Failed to fetch reports from API', error);
        return Promise.reject(error);
      });
  }
  
  private updateReports() {
    // First clear any existing points
    this.clearSelectedPoints();
    EventBus.$emit(Config.MapSetReportPointsEvent, []);

    if (this.selectedWeek === null || !this.allReportsPerTrapGroup.length) {
      return;
    }

    const reports: InsectDamageReport[] = [];
    this.allReportsPerTrapGroup.forEach(reportsForTrapGroup => {
      const reportsForWeek = reportsForTrapGroup.weekReports.find(w =>
        w.year === this.year &&
        w.week === this.selectedWeek);

      if (reportsForWeek !== undefined) {
        reports.push({
          trapGroupId: reportsForTrapGroup.trapGroupId,
          trapGroupName: reportsForTrapGroup.trapGroupName,
          longitude: reportsForTrapGroup.longitude,
          latitude: reportsForTrapGroup.latitude,
          year: reportsForWeek.year,
          week: reportsForWeek.week,
          newGenerationSinceWeek: reportsForTrapGroup.newGenerationSinceWeek !== null &&
                                  reportsForTrapGroup.newGenerationSinceWeek <= reportsForWeek.week
                                    ? reportsForTrapGroup.newGenerationSinceWeek
                                    : null,
          quantity: reportsForWeek.quantity
        });
      }
    });

    EventBus.$emit(Config.MapSetReportPointsEvent, reports);
  }
  
  private setSliderData(reportWeeks: ReportWeek[]) {      
    // This needs to be done before allReportWeeks is set, since once that is set the slider will show.

    this.slider.data = reportWeeks.map(r => r.week);

    this.slider.range = [];
    let hideCounter = 0;
    for (let i = 0; i < reportWeeks.length; i++) {
      this.slider.range.push({
        label: this.$t('week') + ' ' + reportWeeks[i].week,
        
        // hide all but first and each 5th week, but show last week if equal to or less than 5 weeks
        isHide: i !== 0 &&
                hideCounter !== 5 &&
                !(i === (reportWeeks.length - 1) && reportWeeks.length <= 5)
      });
      hideCounter = (hideCounter >= 5 ? 1 : hideCounter += 1);
    }
  }
}
